import { useEffect } from "react";

export const useGestationCalculation = ({ form, pregnancy, anteNatalConsultation }) => {
  useEffect(() => {
    const edd = pregnancy?.estimatedDueDate;
    if (!edd) return;
    const eddDate = new Date(edd);
    const consultDate = anteNatalConsultation?.consultationDate
      ? new Date(anteNatalConsultation.consultationDate)
      : new Date();
    const totalDays =
      280 -
      Math.round(
        (eddDate.getTime() - consultDate.getTime()) / (1000 * 60 * 60 * 24)
      );
    if (totalDays < 0) return;
    form.setValue("gestationWeeks", String(Math.floor(totalDays / 7)));
    form.setValue("gestationDays", String(totalDays % 7));
    // recalculate when pregnancy EDD changes (e.g. data loads after mount)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pregnancy?.estimatedDueDate]);
};
